import React, { useState, useEffect } from 'react';
import { X, Send } from 'lucide-react';

const ContactForm = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [sending, setSending] = useState(false);

const [recaptchaLoaded, setRecaptchaLoaded] = useState(false);

useEffect(() => {
  // Load reCAPTCHA script
  const script = document.createElement('script');
  script.src = 'https://www.google.com/recaptcha/api.js';
  script.async = true;
  script.defer = true;
  script.onload = () => setRecaptchaLoaded(true);
  document.body.appendChild(script);
  
  return () => {
    if (document.body.contains(script)) {
      document.body.removeChild(script);
    }
  };
}, []);
const handleSubmit = async (e) => {
  e.preventDefault();
  setSending(true);
  
  try {
    const response = await fetch('/api/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
	body: JSON.stringify({
  	...formData,
  	'g-recaptcha-response': window.grecaptcha?.getResponse() || ''
	})	     
    });

    if (response.ok) {
      alert('Thank you for your message. We will get back to you soon!');
      setFormData({ name: '', email: '', subject: '', message: '' });
      onClose();
    } else {
      alert('Error sending message. Please try again.');
    }
  } catch (error) {
    console.error('Error:', error);
    alert('Error sending message. Please try again.');
  } finally {
    setSending(false);
  }
};
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">Contact Us</h2>

	  <div className="mb-4">
            <div className="g-recaptcha" data-sitekey="YOUR-SITE-KEY-HERE"></div>
          </div>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <X className="h-6 w-6" />
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-bold mb-2">Name</label>
            <input
              type="text"
              required
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              className="w-full px-3 py-2 border-2 border-black focus:outline-none focus:ring-4 focus:ring-yellow-400"
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-bold mb-2">Email</label>
            <input
              type="email"
              required
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              className="w-full px-3 py-2 border-2 border-black focus:outline-none focus:ring-4 focus:ring-yellow-400"
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-bold mb-2">Subject</label>
            <input
              type="text"
              required
              value={formData.subject}
              onChange={(e) => setFormData({...formData, subject: e.target.value})}
              className="w-full px-3 py-2 border-2 border-black focus:outline-none focus:ring-4 focus:ring-yellow-400"
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-bold mb-2">Message</label>
            <textarea
              required
              rows="4"
              value={formData.message}
              onChange={(e) => setFormData({...formData, message: e.target.value})}
              className="w-full px-3 py-2 border-2 border-black focus:outline-none focus:ring-4 focus:ring-yellow-400"
            />
          </div>
          
          <button
            type="submit"
            disabled={sending}
            className="w-full px-6 py-2 bg-green-600 text-white font-bold hover:bg-green-700 focus:outline-none focus:ring-4 focus:ring-yellow-400 disabled:opacity-50 flex items-center justify-center"
          >
            {sending ? 'Sending...' : (
              <>
                <Send className="h-5 w-5 mr-2" />
                Send Message
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
